export default __webpack_public_path__ + "static/media/junk6.5d6ef6ec.svg";